import avatarSizes from 'src/shared/ui/component/image/setting/avatarSizes';
import type { AvatarVariant } from 'src/shared/ui/component/image/type/avatarTypes';

export function getAvatarSizeFromVariant(
  variant: AvatarVariant,
): number | null | undefined {
  return avatarSizes[variant];
}
